import produce from 'immer';
import { FETCH_KB_FAILED, FETCH_KB_SUCCESS, FETCH_KB_CATEGORIES_SUCCESS, FETCH_KB_CATEGORIES_FAILED } from '../editor/actions/ActionTypes';
import RequestStatus from '../types/RequestStatus';
const initialState = {
  knowledgeBase: {},
  categories: [],
  requestStatus: RequestStatus.UNINITIALIZED,
  categoryRequestStatus: RequestStatus.UNINITIALIZED
};
const knowledgeBaseReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case FETCH_KB_SUCCESS:
      draft.knowledgeBase = action.payload;
      draft.requestStatus = RequestStatus.SUCCEEDED;
      return draft;
    case FETCH_KB_FAILED:
      draft.knowledgeBase = {};
      draft.requestStatus = RequestStatus.FAILED;
      return draft;
    case FETCH_KB_CATEGORIES_SUCCESS:
      draft.categories = action.payload;
      draft.categoryRequestStatus = RequestStatus.SUCCEEDED;
      return draft;
    case FETCH_KB_CATEGORIES_FAILED:
      draft.categories = [];
      draft.categoryRequestStatus = RequestStatus.FAILED;
      return draft;
    default:
      return draft;
  }
});
export default knowledgeBaseReducer;